module.exports = __webpack_public_path__ + "img/m8.f69ad0b.jpg";